const BOOKING_VISITS_URI = '/webservice/getBookingVisits/';
const BOOKING_VISIT_DETAILS = '/webservice/get-today-process';

module.exports = {
  /**
   * Get Booking Visits Via Booking ID
   * @param bookingId
   */
  getBookingVisits: function getBookingVisits(bookingId) {
    return window.axios.get(BOOKING_VISITS_URI, {params: {booking_id: bookingId}});
  },

  getVisitDetails: function getVisitDetails(bookingId, visitBreakDownIds) {
    return window.axios.get(BOOKING_VISIT_DETAILS, {
      params: {
        booking_id: bookingId,
        break_down_ids: visitBreakDownIds
      }
    });
  }

}